<template>
	<div v-loading="loading" :style="{
		minHeight: equipment == 'pc'?'500px':'100vh'
	}" style="user-select:text;width: 100%;background-color: #fff;margin-top: 20px;font-size: 14px;">
		
		<div style="display: flex;" v-if="equipment == 'pc'">
			<div style="width: 50%;">{{$t('h.goods')}}</div>
			<div style="width: 10%;">{{$t('h.num')}}</div>
			<div style="width: 10%;">{{$t('h.serviceType')}}</div>
			<div style="width: 20%;">{{$t('h.created_at')}}</div>
			<div style="width: 10%;">{{$t('h.action')}}</div>
		</div>
		<div v-if="equipment == 'pc'" style="display: flex;margin-top: 10px;padding: 10px;border: solid 1px #e2e2e2;align-items: center;" v-for="(item,index) in list" :key="index">
			<div style="width: 50%;">{{item.product_name}}</div>
			<div style="width: 10%;">{{item.quantity}}</div>
			<div style="width: 10%;">{{item.status_format}}</div>
			<div style="width: 20%;">{{item.created_at}}</div>
			<div style="width: 10%;" class="tit">
				<el-button class="btn-ok" size="mini" style="background-color: #000;border: solid 1px #000;"
					type="primary" @click="lookDetail(item)">{{$t('h.look')}}</el-button>
			</div>
		</div>
		
		<div v-if="equipment == 'phone'" style="display: flex;margin-top: 10px;padding: 10px;border: solid 1px #e2e2e2;align-items: center;flex-direction: column;" v-for="(item,index) in list" :key="index">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<div style="width: 60%;color: #55aaff;">{{item.product_name}}</div>
				<div >x{{item.quantity}}</div>
				<div >{{item.status_format}}</div>
			</div>
			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;margin-top: 20px;">
				<div >{{item.created_at}}</div>
				<div  class="tit">
					<el-button class="btn-ok" size="mini" style="background-color: #000;border: solid 1px #000;"
						type="primary" @click="lookDetail(item)">{{$t('h.look')}}</el-button>
				</div>
			</div>
		</div>
		
		<el-dialog :title="$t('h.afterSales')" :visible.sync="dialogVisible" :width="equipment == 'pc'?'60%':'96%'"
			:before-close="()=>{dialogVisible = false}">
			<div v-loading="detailLoading" style="width: 100%;min-height: 300px;overflow-x: scroll;">
				<div v-if="selectItem" :style="{
					width:equipment == 'pc'?'100%' :'100%'
				}">
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<!-- <div v-for="(item,index) in selectItem.order.order_products" :key="index"
								style="display: flex;align-items: center;">
								<img :src="item.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{item.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{item.price_format}}</div>
										<div style="margin-left: 10px;">x{{item.quantity}}</div>
									</div>
								</div>
							</div> -->
							<div 
								style="display: flex;align-items: center;">
								<img :src="selectItem.orderProduct.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{selectItem.orderProduct.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{selectItem.orderProduct.price_format}}</div>
										<!-- <div style="margin-left: 10px;">x{{item.quantity}}</div> -->
									</div>
								</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;width: 86%;">
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.serviceType')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.type_format}}</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.returnNum')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.quantity}}</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;width: 86%;">
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.status_format')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.status_format}}</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.opendPkg')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.opened?$t('h.yes'):$t('h.no')}}</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;width: 86%;">
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.created_at')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.created_at}}</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.returnReason')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.reason}}</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;width: 86%;">
							<div style="display: flex;align-items: center;">
								<div style="margin-right: 10px;">{{$t('h.img')}}</div>
								<div style="display: flex;flex-wrap: wrap;margin: 4px;"><img :key="index" v-for="(item,index) in selectItem.rma.images" :src="item" style="width: 60px;height: 60px;"/></div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>{{$t('h.memo')}}</div>
								<div style="margin-left: 10px;">{{selectItem.rma.comment}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getRmasData,
		getRmasDataDetail
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				selectItem:null,
				detailLoading:false,
				dialogVisible:false,
				loading:false,
				list:[]
			}
		},
		async mounted() {
			try{
				this.loading = true
				const data = await getRmasData()
				console.log('data',data.data.data.rmas)
				this.list = data.data.data.rmas
				this.loading = false
			}catch(e) {
				this.loading = false
			}
			
		},
		methods:{
			async lookDetail(item) {
				console.log('itemitem',item)
				try{
						this.dialogVisible = true
					this.detailLoading = true
					const data = await getRmasDataDetail({
						id:item.id
					})
					console.log('data',data)
					this.selectItem = data.data.data
				
					// this.list = data.data.data.rmas
					this.detailLoading = false
				}catch(e) {
					this.detailLoading = false
				}
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tit:hover {
		color: #55aaff ;
		cursor: pointer;
	}
	.btn-ok:hover {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
	
	.btn-ok:focus {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
</style>